module.exports = __webpack_public_path__ + "static/media/cattle-drones_hero.dbc4e11c.jpg";